import styled from 'styled-components';
import { GlobalToken } from 'antd';
import { CustomThemeToken } from '@/theme';

interface DrawerContentContainerProps {
  $inMaintenance?: boolean;
  theme: {
    token: CustomThemeToken;
  };
}
export const DrawerContentContainer = styled.div<DrawerContentContainerProps>`
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${({ $inMaintenance, theme: { token } }) =>
    $inMaintenance
      ? `border-left: 1px solid ${token.Ecoplant_Compressor.colorBGMaintenance};`
      : `padding-top: ${token.paddingXL}px;`}

  .maintenance-banner {
    height: ${({ theme: { token } }) => token.marginXL}px;
    width: 100%;
    background-color: ${({ theme: { token } }) => token.Ecoplant_Compressor.colorBGMaintenance};
    padding-left: ${({ theme: { token } }) => token.paddingXS}px;
    display: flex;
    align-items: center;
    color: ${({ theme: { token } }) => token.colorWarningTextHover};
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .drawer-details-header-buttons {
    display: flex;
    justify-content: flex-end;
    padding: 4px 16px 0px 0px;
    align-items: center;
    align-self: stretch;
  }
`;

export const Container = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  min-height: 0;

  .ant-tabs {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;

    .ant-tabs-content-holder {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .ant-tabs-content {
      height: 100%;
    }

    .ant-tabs-nav .ant-tabs-nav-operations {
      display: none;
    }

    .ant-tabs-nav::before {
      border-bottom: ${({ theme: { token } }) => token.lineWidth}px solid
        ${({ theme: { token } }) => token.colorBorderSecondary};
    }

    .ant-tabs-nav-list {
      width: 100%;
      gap: ${({ theme: { token } }) => token.marginXL}px;
    }

    .ant-tabs-tab {
      flex: 1 0 0;
      justify-content: center;
      margin: 0;
      padding: ${({ theme: { token } }) => token.paddingSM}px 0;

      .ant-tabs-tab-btn {
        font-family: ${({ theme: { token } }) => token.fontFamily};
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        color: ${({ theme: { token } }) => token.colorText};
      }
    }

    .ant-tabs-tab.ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        color: ${({ theme: { token } }) => token.colorPrimaryText};
      }
    }

    .ant-tabs-ink-bar {
      height: ${({ theme: { token } }) => token.lineType}px;
      background: ${({ theme: { token } }) => token.colorPrimary};
    }
  }

  .ant-tabs-nav-operations {
    display: none;
  }

  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme: { token } }) => token.paddingLG}px ${({ theme: { token } }) => token.padding}px;

    .header-left {
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.margin}px;
      flex: 1;
      min-width: 0;

      .device-icon-and-type {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        gap: ${({ theme: { token } }) => token.marginXXS}px;

        .device-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          width: 32px;
          height: 32px;

          svg {
            width: 100%;
            height: 100%;
          }
        }
      }

      .device-info {
        display: flex;
        flex-direction: column;
        gap: ${({ theme: { token } }) => token.marginXXS}px;
        padding: ${({ theme: { token } }) => token.marginXS}px 0;
        min-width: 0;

        .device-name {
          font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
          line-height: ${({ theme: { token } }) => token.lineHeightHeading3 * token.fontSizeHeading3}px;
          color: ${({ theme: { token } }) => token.colorText};
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .device-model {
          display: flex;
          align-items: center;
          font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
          line-height: ${({ theme: { token } }) => token.lineHeightLG * token.fontSizeLG}px;
          color: ${({ theme: { token } }) => token.colorTextDescription};
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .header-right {
      display: flex;
      flex-direction: row;
      align-items: start;
      gap: ${({ theme: { token } }) => token.margin}px;
      flex-shrink: 0;
    }
  }
`;

export const FooterSlot = styled.div`
  flex-shrink: 0;
  height: 90px;
  position: relative;
`;
